import React, { useState } from "react";
import { useSelector } from "react-redux";
import Image from "antd/lib/image";
import Default_Brand from "../../../assets/brandLogos/Default_Brand.svg";
import Profile from "../../../assets/Profile_Pic.svg";
import verified from "../../../assets/verified.svg";
import BoostedPostIcon from "../../../assets/boosted_post_icon.svg";
import AdsPostIcon from "../../../assets/ads_post_icon.svg";
import ClockIcon from "../../../assets/Clock.svg";
import FollowersImage from "../../../assets/FollowersBlue.svg";
import { SocialMedialogo } from "../../layout/DeepDive/DeepDivetab/SocialMediaPlatforms";
import { Popover, Tooltip, Badge, Button, Modal } from "antd";
import FilterLogo from "../../../assets/Filter_Logo.svg";
import { getClass, kFormatter } from "../../../redux/constants";
import {
  postCardUserBrandCommentId,
  postCardUserbrandPrivateMessagesId,
} from "../../../redux/constants/enums";
import { getDynamicIconColor } from "../../../redux/constants/DynamicIconColor";

const CustomCardHeader = ({
  el,
  data,
  custom_card_settings,
  PdfDownloadStatus,
  PptGeneratingStatus,
  filterPills,
  metadata,
  postDetail,
}) => {
  const authParams = useSelector((state) => state.Authentication.authParams);
  const allAttributes = useSelector(
    (state) => state?.attributes?.allAttributes
  );
  const personalizationSettingsObj = useSelector(
    (state) => state?.PersonalizationSetting
  );
  const getDefautBrandImg = (e) => {
    return (e.target.src = Default_Brand);
  };

  // console.log(
  //   "CustomCardHeader el=>",
  //   el,
  //   "custom_card_settings",
  //   custom_card_settings
  // );
  let widgetData = metadata;
  return (
    <>
      <div
        className={
          el?.isMenstionCountBlock
            ? " card-head text_heading d-flex justify-content-between p-15 pt-10 pb-0 mt-0 align-items-top influencersMentions__header"
            : `cardList-head card-head text_heading d-flex justify-content-between p-15 mt-0 align-items-top mb-2px ${
                Array.isArray(custom_card_settings?.card_header_1) &&
                custom_card_settings?.card_header_1?.findIndex(
                  (d) => d?.attribute?.toLowerCase() === "sentimenttype"
                ) !== -1 &&
                el?.SentimentType
                  ? "pl-0 pdf__pl--0"
                  : ""
              } ${el?.IsDeletedFromSocial ? "pr-0 pdf__pr--0" : ""}
               ${
                 postCardUserbrandPrivateMessagesId?.includes(el?.channel_type)
                   ? getClass(authParams, "message")
                   : el?.PlatformID == 1 &&
                     el?.ParentSocialID !== "NA" &&
                     el?.ParentSocialID != "0" &&
                     el?.ParentSocialID !== ""
                   ? getClass(authParams, "comment")
                   : postCardUserBrandCommentId?.includes(el?.channel_type) &&
                     el?.PlatformID != 1
                   ? getClass(authParams, "comment")
                   : getClass(authParams, "post")
               }`
        }
      >
        <div
          className="d-flex align-items-center card-head--innnerWrap"
          style={{
            width:
              authParams?.screen_id === "000-000-562" ||
              authParams?.screen_id === "000-000-555"
                ? "70%"
                : el?.isMenstionCountBlock
                ? "100%"
                : "60%",
          }}
        >
          {/* Brand Icon and Profile Icon / card_header_1 */}
          {custom_card_settings?.card_header_1?.length &&
          !el.isMenstionCountBlock ? (
            <>
              {custom_card_settings?.card_header_1?.map((d) => {
                return (
                  <>
                    {d?.attribute?.toLowerCase() === "sentimenttype" &&
                    el?.SentimentType ? (
                      <>
                        <div
                          style={{
                            borderLeft: `0.4rem solid ${
                              el?.SentimentType === "Positive"
                                ? "#5ED142"
                                : el?.SentimentType === "Negative"
                                ? "#FF5D48"
                                : el?.SentimentType === "Neutral"
                                ? "#F0C52F"
                                : "black"
                            }`,
                            height: "3.6rem",
                            marginRight:
                              authParams?.screen_id === "000-000-557" &&
                              !postDetail
                                ? "0.5rem"
                                : "1rem",
                          }}
                        ></div>
                      </>
                    ) : (
                      ""
                    )}

                    {d?.attribute?.toLowerCase() === "rsmallimageurl" ||
                    d?.attribute?.toLowerCase() === "brand_logo" ? (
                      <>
                        {el?.brand_logo &&
                        el?.brand_logo !== "NA" &&
                        el?.BrandFriendlyName &&
                        el?.BrandFriendlyName !== "NA" &&
                        el?.BrandFriendlyName !== "" ? (
                          <Popover
                            placement="leftBottom"
                            title={null}
                            content={
                              <div
                                style={{
                                  maxWidth: "25rem",
                                  maxHeight: "20rem",
                                  overflow: "auto",
                                }}
                                className="text_regular fontSize-12 p-10"
                              >
                                {el?.BrandFriendlyName}
                              </div>
                            }
                            overlayClassName={
                              authParams?.theme_type === "1"
                                ? "darkTheme"
                                : "lightTheme"
                            }
                          >
                            <Image
                              src={
                                el?.brand_logo ? el?.brand_logo : Default_Brand
                              }
                              fallback={
                                el?.brand_logo ? el?.brand_logo : Default_Brand
                              }
                              preview={false}
                              alt="Brand logo"
                              className="profileImg mr-1 cursor-pointer"
                              style={{
                                width: "5rem",
                                height: "5rem",
                              }}
                              onError={getDefautBrandImg}
                              // crossOrigin="anonymous"
                            />
                          </Popover>
                        ) : el?.BrandFriendlyName &&
                          el?.BrandFriendlyName !== "NA" &&
                          el?.BrandFriendlyName !== "" ? (
                          <Popover
                            placement="leftBottom"
                            title={null}
                            content={
                              <div
                                style={{
                                  maxWidth: "25rem",
                                  maxHeight: "20rem",
                                  overflow: "auto",
                                }}
                                className="text_regular fontSize-12 p-10"
                              >
                                {el?.BrandFriendlyName}
                              </div>
                            }
                            overlayClassName={
                              authParams?.theme_type === "1"
                                ? "darkTheme"
                                : "lightTheme"
                            }
                          >
                            <Image
                              src={
                                el?.brand_logo && el?.brand_logo !== "NA"
                                  ? el?.brand_logo
                                  : Default_Brand
                              }
                              fallback={
                                el?.brand_logo && el?.brand_logo !== "NA"
                                  ? el?.brand_logo
                                  : Default_Brand
                              }
                              preview={false}
                              alt="Brand logo"
                              onError={getDefautBrandImg}
                              className="profileImg mr-1 cursor-pointer"
                              style={{
                                width: "5rem",
                                height: "5rem",
                              }}
                              // crossOrigin="anonymous"
                            />
                          </Popover>
                        ) : (
                          <Image
                            src={
                              el?.brand_logo && el?.brand_logo !== "NA"
                                ? el?.brand_logo
                                : Default_Brand
                            }
                            fallback={
                              el?.brand_logo && el?.brand_logo !== "NA"
                                ? el?.brand_logo
                                : Default_Brand
                            }
                            preview={false}
                            alt="Brand logo"
                            onError={getDefautBrandImg}
                            className="profileImg mr-1 cursor-pointer"
                            style={{
                              width: "5rem",
                              height: "5rem",
                            }}
                            // crossOrigin="anonymous"
                          />
                        )}
                      </>
                    ) : (
                      ""
                    )}
                    {d?.attribute?.toLowerCase() === "picurl" ? (
                      <>
                        <div
                          className="position-relative mr-15"
                          style={{ width: "5rem" }}
                        >
                          {!PdfDownloadStatus && !PptGeneratingStatus ? (
                            el?.AuthorBio &&
                            el?.AuthorBio !== "NA" &&
                            el?.AuthorBio !== "" ? (
                              <Popover
                                placement="leftBottom"
                                title={null}
                                content={
                                  el?.AuthorBio &&
                                  el?.AuthorBio !== "NA" &&
                                  el?.AuthorBio !== "" && (
                                    <div
                                      style={{
                                        maxWidth: "25rem",
                                        maxHeight: "20rem",
                                        overflow: "auto",
                                      }}
                                      className="text_regular fontSize-12 p-15 custom_scroll1"
                                    >
                                      {el?.AuthorBio}
                                    </div>
                                  )
                                }
                                overlayClassName={
                                  authParams?.theme_type === "1"
                                    ? "darkTheme"
                                    : "lightTheme"
                                }
                              >
                                <Image
                                  src={
                                    el?.picurl === 0 ||
                                    el?.picurl === "" ||
                                    !el?.picurl
                                      ? Profile
                                      : el?.picurl
                                  }
                                  fallback={Profile}
                                  preview={false}
                                  alt="Profile Images"
                                  className="profileImg m-0 cursor-pointer customCardHeader"
                                  // style={{ width: "3.5rem", height: "3.5rem" }}
                                  // crossOrigin={el?.picurl ? "" : "anonymous"}
                                />
                              </Popover>
                            ) : (
                              <Image
                                src={
                                  el?.picurl === 0 ||
                                  el?.picurl === "" ||
                                  !el?.picurl
                                    ? Profile
                                    : el?.picurl
                                }
                                fallback={Profile}
                                preview={false}
                                alt="Profile Images"
                                className="profileImg m-0 cursor-pointer customCardHeader"
                                // style={{ width: "3.5rem", height: "3.5rem" }}
                                // crossOrigin="anonymous"
                              />
                            )
                          ) : (
                            <Image
                              src={
                                PdfDownloadStatus || PptGeneratingStatus
                                  ? el?.picurl === 0 ||
                                    el?.picurl === "" ||
                                    !el?.picurl
                                    ? Profile
                                    : el?.picurl
                                  : Profile
                              }
                              fallback={Profile}
                              preview={false}
                              alt="Profile Images"
                              className="profileImg m-0 cursor-pointer"
                              style={{ width: "5rem", height: "5rem" }}
                              // crossOrigin="anonymous"
                            />
                          )}
                          {custom_card_settings?.card_header_1?.map((d2) => {
                            return (
                              <>
                                {d2?.attribute?.toLowerCase() ===
                                "socialmediaplatforms" ? (
                                  <>
                                    <div
                                      className={
                                        authParams?.screen_id ===
                                          "000-000-557" && el?.isModalOpen
                                          ? "read-more-channel-icon"
                                          : "position-absolute"
                                      }
                                      style={{
                                        right: "-0.8rem",
                                        top: "-0.2rem",
                                      }}
                                    >
                                      <Image
                                        src={
                                          el?.PlatformID === 0 ||
                                          el?.SocialMediaPlatforms === ""
                                            ? Default_Brand
                                            : el?.PlatformID
                                            ? SocialMedialogo?.[el?.PlatformID]
                                            : el?.SocialMediaPlatforms
                                            ? SocialMedialogo?.[
                                                el?.SocialMediaPlatforms
                                              ]
                                            : Default_Brand
                                        }
                                        alt="Channel"
                                        preview={false}
                                        fallback={Default_Brand}
                                        style={{
                                          width: "2rem",
                                          maxHeight: "2.4rem",
                                          verticalAlign: "top",
                                        }}
                                      />
                                    </div>
                                  </>
                                ) : (
                                  ""
                                )}
                              </>
                            );
                          })}
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                  </>
                );
              })}
            </>
          ) : (
            ""
          )}

          {/* Author Name card_header_2 */}
          <div style={{ width: "calc(100% - 6rem)" }}>
            {custom_card_settings?.card_header_2?.length ? (
              <>
                <div className="d-flex flex-wrap align-items-center">
                  {custom_card_settings?.card_header_2?.map((d) => {
                    return (
                      <>
                        {/* Author Name */}
                        {d?.attribute?.toLowerCase() === "author" && (
                          <Tooltip title={el?.Author}>
                            <div
                              // style={{
                              //   color: "var(--locobuzz-chart-text--color)",
                              // }}
                              className={
                                el?.isMenstionCountBlock
                                  ? "profileName text-left menstion-title-text w-100 line-height-normal postCardTextCC"
                                  : "profileName text-ellipsis line-height-normal postCardTextCC"
                              }
                            >
                              {el?.AuthorURL && el?.AuthorURL !== "NA" ? (
                                <a
                                  className={
                                    el?.AuthorURL &&
                                    el?.AuthorURL !== "NA" &&
                                    !personalizationSettingsObj?.isPersonalizationPreviewOpen
                                      ? ""
                                      : "pointer-events1 cursor-default"
                                  }
                                  href={
                                    el?.AuthorURL && el?.AuthorURL !== "NA"
                                      ? el?.AuthorURL
                                      : ""
                                  }
                                  target="_blank"
                                  rel="noreferrer"
                                  onClick={(e) => {
                                    if (
                                      personalizationSettingsObj?.isPersonalizationPreviewOpen
                                    ) {
                                      e.preventDefault();
                                    }
                                  }}
                                >
                                  {(authParams?.screen_id === "000-000-551" ||
                                    authParams?.screen_id === "000-000-564") &&
                                  window.location.pathname.toLowerCase() ===
                                    "/commandcenter/screens/personalize"
                                    ? el?.Author?.length > 3
                                      ? el?.Author?.substr(0, 3) + " ..."
                                      : el?.Author
                                    : authParams?.screen_id === "000-000-562"
                                    ? el?.Author?.length > 8
                                      ? el?.Author?.substr(0, 8) + " ..."
                                      : el?.Author
                                    : el?.isMenstionCountBlock
                                    ? el?.Author
                                    : el?.Author?.length > 15
                                    ? el?.Author?.substr(0, 15) + " ..."
                                    : el?.Author}
                                </a>
                              ) : (
                                <>
                                  {(authParams?.screen_id === "000-000-551" ||
                                    authParams?.screen_id === "000-000-564") &&
                                  window.location.pathname.toLowerCase() ===
                                    "/commandcenter/screens/personalize"
                                    ? el?.Author?.length > 3
                                      ? el?.Author?.substr(0, 3) + " ..."
                                      : el?.Author
                                    : authParams?.screen_id === "000-000-562"
                                    ? el?.Author?.length > 8
                                      ? el?.Author?.substr(0, 8) + " ..."
                                      : el?.Author
                                    : el?.isMenstionCountBlock
                                    ? el?.Author
                                    : el?.Author?.length > 15
                                    ? el?.Author?.substr(0, 15) + " ..."
                                    : el?.Author}
                                </>
                              )}
                            </div>
                          </Tooltip>
                        )}

                        {/* Author is verified */}
                        {d?.attribute?.toLowerCase() === "isverified" && (
                          <>
                            {el?.isVerified !== "NA" &&
                            el?.isVerified &&
                            (el?.isVerified === "Verified" ||
                              el?.isVerified > 0) ? (
                              // width: 2rem !important;
                              // height: 2rem !important;
                              // margin-right: 0.5rem;
                              <span className="verified profileImg ml-1">
                                {getDynamicIconColor("verifiedIcon")}
                              </span>
                            ) : (
                              // <img
                              //   src={verified}
                              //   alt="verified"
                              //   className="verified profileImg ml-1"
                              //   style={{ height: "16px" }}
                              // />
                              ""
                            )}
                          </>
                        )}

                        {/* Promoted post */}
                        {d?.attribute?.toLowerCase() === "ispromoted" && (
                          <>
                            {el?.isPromoted === 1 ? (
                              <Tooltip title="Boosted post">
                                <img
                                  alt="Boosted Post Icon"
                                  src={BoostedPostIcon}
                                  className="mr-0"
                                  style={{
                                    width: "2rem",
                                    height: "2rem",
                                  }}
                                />
                              </Tooltip>
                            ) : el?.isPromoted === 2 || el?.isPromoted === 5 ? (
                              <Tooltip
                                title={
                                  el?.isPromoted === 5
                                    ? "Dark Ad Post"
                                    : "Ad Post"
                                }
                              >
                                <img
                                  alt="Ad Post Icon"
                                  src={AdsPostIcon}
                                  className="mr-0"
                                  style={{
                                    width: "2rem",
                                    height: "2rem",
                                  }}
                                />
                              </Tooltip>
                            ) : (
                              ""
                            )}
                          </>
                        )}
                      </>
                    );
                  })}
                </div>
                <div className="d-flex flex-wrap align-items-center">
                  {custom_card_settings?.card_header_2?.map((d) => {
                    return (
                      <>
                        {/* Author Screen Name */}
                        {d?.attribute?.toLowerCase() === "authorscreenname" ? (
                          <>
                            {el?.AuthorScreenName &&
                            el?.PlatformID !== 2 &&
                            el?.PlatformID !== 5 ? (
                              <div
                                className="screenName text-grayLight text-ellipsis w-100"
                                //style={{ width: "90%" }}
                              >
                                <Tooltip title={el?.AuthorScreenName}>
                                  {el?.AuthorURL && el?.AuthorURL !== "NA" ? (
                                    <a
                                      className={
                                        el?.AuthorURL && el?.AuthorURL !== "NA"
                                          ? ""
                                          : "pointer-events1 cursor-default"
                                      }
                                      href={
                                        el?.AuthorURL && el?.AuthorURL !== "NA"
                                          ? el?.AuthorURL
                                          : ""
                                      }
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      {el?.AuthorScreenName}
                                    </a>
                                  ) : (
                                    <>{el?.AuthorScreenName}</>
                                  )}
                                </Tooltip>
                              </div>
                            ) : (
                              ""
                            )}
                          </>
                        ) : (
                          ""
                        )}

                        {/* Followers Count */}
                        {el?.PlatformID === 1 &&
                        !el?.isMenstionCountBlock &&
                        d?.attribute?.toLowerCase() === "followerscount" ? (
                          <div
                            className={`${
                              authParams?.screen_id === "000-000-562"
                                ? "d-flex align-items-center"
                                : ""
                            } "screenName text-grayLight text-ellipsis w-100 mb-15"`}
                          >
                            <Tooltip title={"Followers"}>
                              <span>
                                {getDynamicIconColor("FollowersIcon")}
                              </span>
                              {/* <img
                                src={FollowersImage}
                                alt="Followers Image"
                                className="profileImg mr-1 customCardIcon align-items-center"

                              /> */}
                            </Tooltip>
                            <Tooltip
                              title={el?.FollowersCount?.toLocaleString()}
                            >
                              <span
                                className={`customCardFollower${
                                  window.location.pathname
                                    .toLowerCase()
                                    .includes("/commandcenter/screens")
                                    ? "dynamic_icon_color"
                                    : ""
                                }`}
                              >
                                {" "}
                                {kFormatter(el?.FollowersCount)}
                              </span>
                            </Tooltip>
                          </div>
                        ) : (
                          ""
                        )}
                      </>
                    );
                  })}
                </div>
              </>
            ) : (
              ""
            )}
          </div>
        </div>

        {/* Date or Brand Name card_header_3 */}
        <span
          className="font-size12 align-items-center d-flex flex-direction-row-reverse date-icons-header"
          style={{ maxWidth: "40%" }}
        >
          {custom_card_settings?.card_header_3?.length &&
          !el?.isMenstionCountBlock ? (
            <>
              {/* IsDeletedFromSocial */}
              {el?.IsDeletedFromSocial ? (
                <>
                  <Tooltip
                    title={<div>Deleted From Social</div>}
                    placement="topRight"
                    className="no--wrap"
                  >
                    <span
                      className={`deletedFromSocialIcon ${"d-flex align-items-center"} `}
                    >
                      <i className="fas fa-trash-alt trash__icon"></i>
                    </span>
                  </Tooltip>
                </>
              ) : (
                ""
              )}
              {custom_card_settings?.card_header_3?.map((d) => {
                return (
                  <>
                    {/* Created Date and Post Created Date */}
                    {d?.attribute?.toLowerCase() === "createddate" ? (
                      <>
                        <Tooltip
                          title={
                            <div>
                              Created Date : <br />{" "}
                              {el?.CreatedDate_tooltip
                                ? el?.CreatedDate_tooltip
                                : el?.CreatedDate}
                            </div>
                          }
                          // className="no--wrap"
                          className={`${
                            authParams?.screen_id === "000-000-562"
                              ? "d-flex align-items-center"
                              : "no--wrap"
                          }`}
                        >
                          <span
                            className={`${
                              authParams?.screen_id
                                ? "command_center_cardList__footer-label"
                                : "cardList__footer-label"
                            }`}
                          >
                            {getDynamicIconColor("clock_icon")}
                          </span>
                          {/* <img
                            src={ClockIcon}
                            className={`${
                              authParams?.screen_id
                                ? "command_center_cardList__footer-label"
                                : "cardList__footer-label"
                            }`}
                            alt="ClockIcon"
                            style={{ width: "4.5rem" }}
                          /> */}
                          <span
                            className={`${
                              authParams?.screen_id === "000-000-562"
                                ? "cardList__footer-count text-grayLight fontSize-16"
                                : "cardList__footer-count text-grayLight fontSize-18"
                            }`}
                            // style={{
                            //   color: "var(--locobuzz-primary-text-color)",
                            // }}
                          >
                            {el?.CreatedDate}
                          </span>
                        </Tooltip>
                      </>
                    ) : (
                      ""
                    )}

                    {/* Brand Logo And Brand Name */}
                    {d?.attribute?.toLowerCase() === "brand_logo" ? (
                      <>
                        {el?.brand_logo &&
                        el?.brand_logo !== "NA" &&
                        el?.BrandFriendlyName &&
                        el?.BrandFriendlyName !== "NA" &&
                        el?.BrandFriendlyName !== "" ? (
                          <Popover
                            placement="leftBottom"
                            title={null}
                            content={
                              <div
                                style={{
                                  maxWidth: "25rem",
                                  maxHeight: "20rem",
                                  overflow: "auto",
                                }}
                                className="text_regular fontSize-12 p-10"
                              >
                                {el?.BrandFriendlyName}
                              </div>
                            }
                            overlayClassName={
                              authParams?.theme_type === "1"
                                ? "darkTheme"
                                : "lightTheme"
                            }
                          >
                            <Image
                              src={
                                el?.brand_logo ? el?.brand_logo : Default_Brand
                              }
                              fallback={
                                el?.brand_logo ? el?.brand_logo : Default_Brand
                              }
                              preview={false}
                              alt="Brand logo"
                              className="profileImg ml-1 cursor-pointer"
                              style={{
                                width: "2.5rem",
                                height: "2.5rem",
                                //marginTop: "-0.5rem",
                              }}
                              onError={getDefautBrandImg}
                              // crossOrigin="anonymous"
                            />
                          </Popover>
                        ) : el?.BrandFriendlyName &&
                          el?.BrandFriendlyName !== "NA" &&
                          el?.BrandFriendlyName !== "" ? (
                          <Popover
                            placement="leftBottom"
                            title={null}
                            content={
                              <div
                                style={{
                                  maxWidth: "25rem",
                                  maxHeight: "20rem",
                                  overflow: "auto",
                                }}
                                className="text_regular fontSize-12 p-10"
                              >
                                {el?.BrandFriendlyName}
                              </div>
                            }
                            overlayClassName={
                              authParams?.theme_type === "1"
                                ? "darkTheme"
                                : "lightTheme"
                            }
                          >
                            <Image
                              src={
                                el?.brand_logo && el?.brand_logo !== "NA"
                                  ? el?.brand_logo
                                  : Default_Brand
                              }
                              fallback={
                                el?.brand_logo && el?.brand_logo !== "NA"
                                  ? el?.brand_logo
                                  : Default_Brand
                              }
                              preview={false}
                              alt="Brand logo"
                              onError={getDefautBrandImg}
                              className="profileImg ml-1 cursor-pointer"
                              style={{
                                width: "2.5rem",
                                height: "2.5rem",
                                //marginTop: "-0.5rem",
                              }}
                              // crossOrigin="anonymous"
                            />
                          </Popover>
                        ) : (
                          <Image
                            src={
                              el?.brand_logo && el?.brand_logo !== "NA"
                                ? el?.brand_logo
                                : Default_Brand
                            }
                            fallback={
                              el?.brand_logo && el?.brand_logo !== "NA"
                                ? el?.brand_logo
                                : Default_Brand
                            }
                            preview={false}
                            alt="Brand logo"
                            onError={getDefautBrandImg}
                            className="profileImg ml-1 cursor-pointer"
                            style={{
                              width: "2.5rem",
                              height: "2.5rem",
                              //marginTop: "-0.5rem",
                            }}
                            // crossOrigin="anonymous"
                          />
                        )}
                      </>
                    ) : (
                      ""
                    )}

                    {/* Brand Name */}
                    {d?.attribute?.toLowerCase() === "brandname" && (
                      <Tooltip title={el?.BrandName}>
                        <div className="ml-1 profileName text-ellipsis line-height-normal">
                          {authParams?.screen_id === "000-000-557" &&
                          filterPills?.length
                            ? filterPills?.[0]?.text?.length > 12
                              ? filterPills?.[0]?.text?.substr(0, 12) + " ..."
                              : filterPills?.[0]?.text
                            : el?.BrandName?.length > 12
                            ? el?.BrandName?.substr(0, 12) + " ..."
                            : el?.BrandName
                            ? el?.BrandName
                            : el?.BrandFriendlyName?.length > 12
                            ? el?.BrandFriendlyName?.substr(0, 12) + " ..."
                            : el?.BrandFriendlyName}
                        </div>
                      </Tooltip>
                    )}
                  </>
                );
              })}
            </>
          ) : (
            ""
          )}
        </span>
        {el?.isMenstionCountBlock && authParams?.screen_id === "000-000-553" ? (
          <div style={{ marginTop: "1rem" }}>
            <Tooltip
              title={
                widgetData?.filters?.length ? (
                  <div
                    className="custom_scroll "
                    style={{
                      maxWidth: "27rem",
                      maxHeight: "23rem",
                      overflow: "auto",
                      scrollBehavior: "smooth",
                    }}
                  >
                    <div className="mb-1">
                      {widgetData?.filters?.map((el) => {
                        return widgetData?.filters?.length ? (
                          <div className="mb-2">
                            <p className="mb-0 text-white">
                              <strong>
                                {allAttributes
                                  ? allAttributes[el?.attribute]
                                    ? allAttributes[el?.attribute]
                                    : el?.attribute?.toLowerCase() ===
                                      "categoryid"
                                    ? "Category"
                                    : el?.attribute?.toLowerCase() ===
                                      "subcategoryid_aug"
                                    ? "Sub Category"
                                    : el?.attribute?.toLowerCase() ===
                                      "subsubcategoryid"
                                    ? "Sub Sub Category"
                                    : el?.attribute?.endsWith("ID")
                                    ? el?.attribute?.replace("ID", "")
                                    : el?.attribute?.replace("Type", "")
                                  : el?.attribute?.endsWith("ID")
                                  ? el?.attribute?.replace("ID", "")
                                  : el?.attribute?.replace("Type", "")}
                              </strong>
                            </p>
                            {el?.type === "int" &&
                              !Array.isArray(el?.columns) && (
                                <span className="font-weight-light text-white">
                                  {el?.columns?.from + " - " + el?.columns?.to}
                                </span>
                              )}
                            {Array.isArray(el?.columns) &&
                              el?.columns?.map((e, index) => {
                                return (
                                  <span
                                    className="font-weight-light"
                                    style={{
                                      color:
                                        e?.type === "include"
                                          ? "#5ed66d"
                                          : e?.type === "exclude"
                                          ? "#fb7665"
                                          : "#fff",
                                    }}
                                  >
                                    {[
                                      "FeedBackEnabled",
                                      "ShowDeletedFromSocial",
                                      "AutoClosureEnabled",
                                      "IsWorkingHour",
                                    ]?.includes(el?.attribute)
                                      ? e?.name === null
                                        ? "Any"
                                        : e?.name === 0
                                        ? "No"
                                        : e?.name === 1 && "Yes"
                                      : (index ? ", " : "") +
                                        (e?.display_name
                                          ? e?.display_name
                                          : e?.name)}
                                  </span>
                                );
                              })}
                          </div>
                        ) : (
                          "Filter"
                        );
                      })}
                    </div>
                  </div>
                ) : (
                  "Filter"
                )
              }
            >
              <Badge
                style={{
                  backgroundColor: "#185edf",
                  fontSize: "1rem",
                }}
                size="small"
                count={
                  widgetData?.filters?.length ? widgetData?.filters?.length : 0
                }
              >
                <img
                  className="cursor-pointer Screen__icons--settings"
                  src={FilterLogo}
                  style={{
                    padding: "0.2rem",
                    width: "2rem",
                    height: "2rem",
                  }}
                />
              </Badge>
            </Tooltip>
          </div>
        ) : (
          ""
        )}
      </div>
    </>
  );
};

export default CustomCardHeader;
